import { createSlice } from "@reduxjs/toolkit"
import {
  addNewBranch,
  cloneBranch,
  copyBranchSettings,
  deleteBranch,
  getAllBranchsList,
  getBranchDetails,
  updateBranch,
  updateBranchStatus,
  updateMultiplesBranch,
} from "store/actions/branchsActions"

const initialState = {
  loading: true,
  error: null,
  isLoading: false,
  actionType: null,
  message: null,
  itemsPerPage: 100,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  isUpdating: false,
  branchsList: [],
  branchDetails: {},
}

const usersSlice = createSlice({
  name: "name", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH ALL BRANCHS
    builder
      .addCase(getAllBranchsList.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
      })
      .addCase(getAllBranchsList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.branchsList = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllBranchsList.rejected, (state, action) => {
        state.loading = false
        state.branchsList = []
      })

    // UPDATE BRANCH STATUS
    builder
      .addCase(updateBranchStatus.pending, state => {
        state.error = null
        state.actionType = null
        state.isUpdating = true
        state.message = null
      })
      .addCase(updateBranchStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload
        if (status) {
          const { id, status, remark } = action.meta.arg
          state.branchsList = state.branchsList.map(branch =>
            branch._id === id ? { ...branch, status: Number(status) } : branch
          )
          state.branchDetails = {
            ...state.branchDetails,
            status: Number(status),
            remark,
          }
        }
      })
      .addCase(updateBranchStatus.rejected, (state, action) => {
        state.isUpdating = false
        state.branchsList = [] //
      })

    //   ADD NEW BRANCH
    builder
      .addCase(addNewBranch.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(addNewBranch.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          state.actionType = "ADD_LOCATION_SUCCESS"
          state.message = action.payload.msg
          if (action.meta.arg && action.meta.arg.navigate) {
            action.meta.arg.navigate("/branches")
          }
        } else {
          state.isLoading = false
          state.error = action.payload.msg
          state.actionType = "ADD_LOCATION_FAILED"
        }
      })
      .addCase(addNewBranch.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE BRANCH
    builder
      .addCase(deleteBranch.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
      })
      .addCase(deleteBranch.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id, setShowDeleteModal } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.branchsList = state.branchsList.filter(item => item._id !== id) //
          state.error = null
          state.actionType = "BRANCH_DELETE_SUCCESS"
          state.message = msg
          setShowDeleteModal(false)
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        } else {
          state.actionType = "BRANCH_DELETE_FAILED"
          state.error = msg
          state.isLoading = false
        }
      })
      .addCase(deleteBranch.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET BRANCH DETAILS
    builder
      .addCase(getBranchDetails.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
        state.branchDetails = {}
      })
      .addCase(getBranchDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.branchDetails = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getBranchDetails.rejected, (state, action) => {
        state.loading = false
        state.branchDetails = []
      })

    // EDIT BRANCH
    builder
      .addCase(updateBranch.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(updateBranch.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          state.actionType = "UPDATE_BRANCH_SUCCESS"
          state.message = action.payload.msg
        } else {
          state.actionType = "UPDATE_BRANCH_FAILED"
          state.error = action.payload.msg
        }
      })
      .addCase(updateBranch.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE MULTIPLES BRANCH

    builder
      .addCase(updateMultiplesBranch.pending, state => {
        state.isLoading = true
      })
      .addCase(updateMultiplesBranch.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateMultiplesBranch.rejected, (state, action) => {
        state.isLoading = false
      })

    // COPY BRANCH SETTINGS
    builder
      .addCase(copyBranchSettings.pending, state => {
        state.isLoading = true
      })
      .addCase(copyBranchSettings.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(copyBranchSettings.rejected, (state, action) => {
        state.isLoading = false
      })

    // CLONE BRANCH
    builder
      .addCase(cloneBranch.pending, state => {
        state.isLoading = true
      })
      .addCase(cloneBranch.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(cloneBranch.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
